import { api } from "@/api";
import { ChatWidgetPollRequest, ChatWidgetPollResponse } from "@/types";

/**
 * Poll for new turns and the current handoff status while a live-chat handoff is
 * active.
 *
 * The backend returns turns strictly newer than `after` (an ISO timestamp) plus
 * the conversation's `handoff_status`, so the widget can render operator (agent)
 * replies and know when the bot has resumed. Live message content lives in
 * Postgres, so no Firebase dependency is needed on the client.
 *
 * @param siteId - TOMIS site slug
 * @param args - user/conversation ids and optional `after` cursor
 */
export async function pollConversation(
  siteId: string,
  args: { userId: string; conversationId: string; after?: string },
): Promise<{ data?: ChatWidgetPollResponse; error?: string }> {
  const { userId, conversationId, after } = args;

  const body: ChatWidgetPollRequest = {
    user_id: userId,
    conversation_id: conversationId,
  };

  if (after) {
    body.after = after;
  }

  return api.post<ChatWidgetPollResponse>(`/${siteId}/chat-widget/poll/`, body);
}
